import React from 'react'

import '../ServePost.css'

import ChevronRightArrow from '../../../assets/ChevronArrow.svg'
import oytv0 from '../../../assets/visual/graphic_oytv/olivTV_000.png'
import oytv1 from '../../../assets/visual/graphic_oytv/olivTV_001.png'
import oytv2 from '../../../assets/visual/graphic_oytv/olivTV_002.gif'
import oytv3 from '../../../assets/visual/graphic_oytv/olivTV_003.png'
import oytv4 from '../../../assets/visual/graphic_oytv/olivTV_003_2.png'
import oytv5 from '../../../assets/visual/graphic_oytv/olivTV_004.png'
import oytv6 from '../../../assets/visual/graphic_oytv/olivTV_004_2.png'

function VisualPost9() {
    return (
        <div className='serve-content-body'>
            <img className='content-img' src={oytv0} alt="" />
            <img className='content-img' src={oytv1} alt="" />
            <img className='content-img' src={oytv2} alt="" />
            <img className='content-img' src={oytv3} alt="" />
            <img className='content-img' src={oytv4} alt="" />
            <img className='content-img' src={oytv5} alt="" />
            <img className='content-img' src={oytv6} alt="" />
        </div>
    )
}

export default VisualPost9